export function getBadgeState(isActive: boolean, isCompleted: boolean) {
  if (isActive) {
    return "active";
  }

  if (!isActive && isCompleted) {
    return "completed_inactive";
  }

  if (!isActive && !isCompleted) {
    return "in_progress_inactive";
  }

  return "default";
}
